import { ReducerBuilder } from './reducerBuilder';
import { AuthState } from 'acscp/store/authState';
import { PasswordTokenRequest, RefreshTokenRequest, VerifyAccountTokenRequest } from 'acscp/api/requests';
import { Token } from 'acscp/api/models/token';
import {
    AddSharingToken,
    ContinueAsGuest,
    EnterNonJetPortalMode,
    LeaveGuestMode,
    RemoveLoginToken,
    RemoveSharingTokens,
} from '../actions';
import { ResponseType } from 'acscp/api/responses/core/responseTypes';

const initialState: AuthState = {
    sharingTokens: [],
    guestLogin: false,
    isNonJetPortalUser: false
};

export const authReducer =
    new ReducerBuilder<AuthState>(initialState)
        .successfulRequestCase(PasswordTokenRequest, (state, payload: Token, request) => ({
            ...state,
            token: payload.access_token,
            refreshToken: payload.refresh_token,
            username: request.username,
            loginPageVariant: request.loginPageVariant
        }))
        .successfulRequestCase(RefreshTokenRequest, (state, payload: Token, request) => ({
            ...state,
            token: payload.access_token,
            refreshToken: payload.refresh_token,
            username: request.username,
        }))
        .successfulRequestCase(VerifyAccountTokenRequest, (state, payload: Token, request) => ({
            ...state,
            token: payload.access_token,
            refreshToken: payload.refresh_token,
            username: request.username,
        }))
        .failedRequestCase(RefreshTokenRequest, (state, responseType) => {
            if (responseType === ResponseType.Unauthorized) {
                return {
                    ...state,
                    refreshToken: undefined
                };
            }
            return state;
        })
        .actionCase(AddSharingToken, (s, a) => {
            const tokens = s.sharingTokens ? [...s.sharingTokens] : [];
            if (tokens.indexOf(a.token) === -1) {
                tokens.push(a.token);
            }
            return {
                ...s,
                sharingTokens: tokens
            };
        })
        .actionCase(RemoveSharingTokens, (s, a) => {
            const tokens = s.sharingTokens ?
                s.sharingTokens.filter(t => a.tokens.indexOf(t) === -1) : [];

            return {
                ...s,
                sharingTokens: tokens,
                guestLogin: s.guestLogin && tokens.length > 0
            };
        })
        .actionCase(ContinueAsGuest, (s, a) => {
            return {
                ...s,
                guestLogin: true
            };
        })
        .actionCase(LeaveGuestMode, (s, a) => {
            return {
                ...s,
                guestLogin: false
            };
        })
        .actionCase(EnterNonJetPortalMode, (s, a) => {
            return {
                ...s,
                isNonJetPortalUser: true
            };
        })
        .actionCase(RemoveLoginToken, (s, a) => {
            return {
                ...s,
                token: undefined
            };
        })
        .build();
